import { render, staticRenderFns } from "./BarcodeViewer.vue?vue&type=template&id=38dd8302&"
import script from "./BarcodeViewer.vue?vue&type=script&lang=js&"
export * from "./BarcodeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports